import { Inject, Injectable } from '@angular/core';
// NgRx
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { Store } from '@ngrx/store';
// RxJs
import { of } from 'rxjs';
import { catchError, map, tap, startWith, exhaustMap } from 'rxjs/operators';
import { concatLatestFrom } from '@ngrx/operators';
// Actions
import * as actions from './actions';
// Services
import { PlAuthService } from '../services';
import { PL_API_CONFIG } from '../tokens';
import { PlAPIConfig } from '../models';
import { selectAuth } from './selectors';

@Injectable()
export class PlAuthEffects {
  private loginUrl: string;

  constructor(
    @Inject(PL_API_CONFIG) config: PlAPIConfig,
    private plAuth: PlAuthService,
    private actions$: Actions,
    private store: Store
  ) {
    this.loginUrl = config.login_url;
  }

  private redirectTo(url: string) {
    window.location.href = url;
  }

  checkUserStatus = createEffect(() =>
    this.actions$.pipe(
      ofType(actions.PLCheckUserStatus),
      concatLatestFrom(() => this.store.select(selectAuth)),
      exhaustMap(([{ lastActive }, authState]) => {
        if (!authState.isSiriusEnabled) {
          return this.plAuth.getUserStatus(lastActive).pipe(
            map(actions.PLAuthSuccess),
            startWith(actions.PLAuthPending()),
            catchError((error) => of(actions.PLAuthError({ error })))
          );
        }
        // If Sirius is enabled, do nothing
        return of();
      })
    )
  );

  redirectToLogin$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(actions.PLLoginRedirect),
        concatLatestFrom(() => this.store.select(selectAuth)),
        tap(([{ url }, authState]) => {
          if (!authState.isSiriusEnabled) {
            this.redirectTo(
              `${this.loginUrl}/login/?next=${window.location.origin}${url}`
            );
          }
        })
      ),
    { dispatch: false }
  );
}
